import { Container, Typography } from '@material-ui/core';
import React from 'react';
export const NotAuthorized = () => /*#__PURE__*/React.createElement(Container, {
  maxWidth: "sm"
}, /*#__PURE__*/React.createElement(Typography, {
  component: "h1",
  gutterBottom: true
}, "Authorization"), /*#__PURE__*/React.createElement(Typography, {
  variant: "body1"
}, "You are not authorized to access this resource."));
//# sourceMappingURL=not-authorized.js.map